module.exports = __webpack_public_path__ + "static/media/big-load.7677edd5.gif";